import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, FileText, Activity, Calendar, Shield, Gift } from 'lucide-react';
const deliverables = [{
  icon: FileText,
  title: 'The Master Guide "21-Day Energy Reset" (PDF)',
  description: 'The step-by-step manual to saturate your reserves.'
}, {
  icon: Activity,
  title: 'The Gap Signal Test',
  description: 'Identify in 2 minutes which exact nutrient your brain is missing today.'
}, {
  icon: Calendar,
  title: 'Strategic Supplementation Plan',
  description: 'When and how to take each support so your body actually absorbs it.'
}, {
  icon: Shield,
  title: '"Shield Foods" List',
  description: 'The 12 ingredients that protect your energy levels during weeks of stress.'
}, {
  icon: Gift,
  title: 'Bonus: Support Selection Guide',
  description: "What to look for on a label so you don't waste your money."
}];
export function WhatYouGet() {
  return <section className="py-24 px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-174">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-16" data-id="element-175">
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-176">What You Get</h2>
        <p className="text-xl text-charcoal/70" data-id="element-177">
          Everything you need to execute the protocol immediately.
        </p>
      </motion.div>

      <div className="space-y-4" data-id="element-178">
        {deliverables.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="flex items-start gap-4 p-6 bg-white rounded-2xl border border-forest/10 shadow-sm hover:border-forest/30 transition-colors" data-id="element-179">
            <div className="mt-1 text-forest" data-id="element-180">
              <CheckCircle2 size={24} data-id="element-181" />
            </div>
            <div data-id="element-182">
              <h3 className="text-xl font-bold text-forest mb-1" data-id="element-183">
                {item.title}
              </h3>
              <p className="text-charcoal/70" data-id="element-184">{item.description}</p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}